export default class Cookie {
  static set(name, value) {
    document.cookie = `${name}=${value}`
  }

  static set(name, value, domain, expires) {
    if (!expires) expires = 0
    console.warn(`${name}=${value};expires=${expires};domain=${domain}`)
    document.cookie = `${name}=${value}; domain=${domain}; expires=${expires}`
  }

  static get(name) {
    var cookieArr = document.cookie.split(';')

    for (var i = 0; i < cookieArr.length; i++) {
      var cookiePair = cookieArr[i].split('=')

      if (name == cookiePair[0].trim()) {
        return decodeURIComponent(cookiePair[1])
      }
    }

    return null
  }
}
